import { itemsDemo } from './item';
import { usersDemo } from './user';
import { COINFLIP_SIDE_BLUE, COINFLIP_SIDE_RED, Coinflip } from '@models/coinflip.interface';
import { User } from '@models/user.interface';

export const coinflips = {
  gameid: 2700,
  hash: 'asdfasdsadasdassadsdds',
  value: 53.24,
  min_val: 43.24,
  max_val: 63.24,
  status: 'finished',
  start: 0,
  ends: 0,
  host: {
    id: 2,
    level: 5,
    name: 'Hirsw0w',
    steamid: '21312321',
    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5b56e2b47974686bb293ace33ed34be972af8a4_full.jpg',
    value: 13.24,
    chance: 49,
    side: COINFLIP_SIDE_BLUE,
    skins: [
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
    ],
  },
  part: {
    id: 3,
    level: 5,
    name: 'Hirsw0w',
    steamid: '21312321',
    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5b56e2b47974686bb293ace33ed34be972af8a4_full.jpg',
    value: 13.24,
    chance: 51,
    side: COINFLIP_SIDE_RED,
    skins: [
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
    ],
  },
  winner: {
    id: 2,
    level: 5,
    name: 'Hirsw0w',
    steamid: '21312321',
    avatar: 'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5b56e2b47974686bb293ace33ed34be972af8a4_full.jpg',
    value: 13.24,
    chance: 49,
    side: COINFLIP_SIDE_BLUE,
    skins: [
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
      {
        name: 'Strange Professional Killstreak Fists of Steel',
        price: 4.24,
        image:
          'https://steamcommunity-a.akamaihd.net/economy/image/fWFc82js0fmoRAP-qOIPu5THSWqfSmTELLqcUywGkijVjZULUrsm1j-9xgEIUwEYTg_xhzdFt9vyCPeAN-wBid0wq5YCjWI-xlQjZrHhZDJmJweVB_AJDqxjplq1DXYz6cEzUo63ruNQLQzx9NyRIporuzw/45fx45f',
        color: '#ff0000',
        type: 1,
      },
    ],
  },
  module: 0.734634344,
  server_seed: 'asdMAdcjA',
  secret: 'adshmikfr',
  random_seed: 'asdasdsa',
  signature: 'asdasd',
  serialid: 2323,
};

export function generateCoinflipRound(status: Coinflip['status'], steve = false): Coinflip {
  const host = getRandomUser();
  const part = status !== 'open' ? getRandomUser(steve) : null;

  const hostSkins = generateSkins();
  const partSkins = status !== 'open' && status !== 'joining' ? generateSkins() : null;

  const hostValue = hostSkins.reduce((acc, item) => acc + item.price, 0);
  const partValue = partSkins ? partSkins.reduce((acc, item) => acc + item.price, 0) : 0;
  const hostChance = Math.floor((hostValue / (hostValue + partValue)) * 100);
  const partChance = part ? 100 - hostChance : 0;

  const hostSide = Math.random() > 0.5 ? COINFLIP_SIDE_BLUE : COINFLIP_SIDE_RED;
  const partSide = part ? (hostSide === COINFLIP_SIDE_BLUE ? COINFLIP_SIDE_RED : COINFLIP_SIDE_BLUE) : COINFLIP_SIDE_BLUE;

  const hostObject = {
    ...host,
    value: hostValue,
    chance: hostChance,
    side: hostSide,
    skins: hostSkins,
    id: Math.random() * 10000,
  };

  const partObject = part
    ? {
        ...part,
        value: partValue,
        chance: partChance,
        side: partSide,
        skins: partSkins,
        id: Math.random() * 20000,
      }
    : null;

  const module = Math.random();
  const winner = status === 'joined' || status === 'finished' ? (module < hostChance / 100 ? hostObject : partObject) : null;

  let end = new Date().getTime();
  if (status === 'joining') {
    end += 1000 * 90;
  } else if (status === 'joined') {
    end += 1000 * 3;
  }
  const game: Coinflip = {
    gameid: Math.floor(Math.random() * 10000),
    hash: generateRandomHash(),
    value: hostValue + partValue,
    rehosts: 0,
    start_time: 1,
    min_val: hostValue * 0.9,
    max_val: hostValue * 1.1,
    status: status,
    joining: true,
    start: Math.floor(new Date().getTime() / 1000),
    end: Math.floor(end / 1000),
    host: hostObject,
    winner: winner,
    part: partObject,
    timer: 0,
    module: module,
    gap_perc: 0,
    host_bp: 0,
    partchoice: 0,
    last_ann: 0,
    secret: [generateRandomHash()],
    // signature: generateRandomHash(),
    // serialid: Math.floor(Math.random() * 10000),
  };

  return game;
}

export function getRandomUser(steve = false): User {
  let user = usersDemo[Math.floor(Math.random() * usersDemo.length)];
  if (steve) {
    user = {
      ...user,
      id: -1,
      steamid: '-1',
      name: 'BOT Steve',
    };
  }
  return user;
}

export function generateSkins() {
  const items = [];
  // get random number of items between 1 and 10 from itemsDemo
  const itemsCount = Math.floor(Math.random() * 10) + 1;
  for (let i = 0; i < itemsCount; i++) {
    items.push(itemsDemo[Math.floor(Math.random() * itemsDemo.length)]);
  }
  return items;
}

function generateRandomHash() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
